// React hooks
import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";

// Helpers i API servisi
import { useTranslate } from "helpers";

// Tipovi i konstante
import { VehicleOfferSearchPageCmp, VehicleOfferSearchPageProps } from "./types";
import { FLEET_VEHICLE_OFFER_SEARCH_PAGE_TITLE } from "ui/components/PageTitle/consts";

// UI komponente

// Moduli specifični za projekt
import { Routes as FleetVehicleRoutes } from "ui/modules/fleet/vehicles/navigation";

// Lokalne komponente
import { initialFleetVehicleDetailForm } from "services/api/fleet/vehicles/consts";
import { FleetVehicleDetailFormValues } from "services/api/fleet/vehicles/types";
import { getFleetVehicleAPI } from "services/api/fleet/vehicles/api";
import { Errors } from "services/forms/validation/types";
import { Tabs } from "ui/components/Tabs";
import TabMenu from "ui/modules/fleet/vehicles/pages/components/TabMenu/TabMenu";
import { VehicleTabHeader } from "ui/modules/fleet/vehicles/pages/components/VehicleTabHeader";
import VehicleOfferSaleSearchPage from "./components/VehicleOfferSaleSearchPage/VehicleOfferSaleSearchPage";
import VehicleOfferRentSearchPage from "./components/VehicleOfferRentSearchPage/VehicleOfferRentSearchPage";


const VehicleOfferSearchPage: VehicleOfferSearchPageCmp = (
  props: VehicleOfferSearchPageProps
) => {

  const { id } = useParams();
  const { t } = useTranslate();

  const [formValues, setFormValues] = useState<FleetVehicleDetailFormValues>(
    initialFleetVehicleDetailForm
  );

  // const [selectedRows, setSelectedRows] = useState<number[]>([]);
  const [errors, setErrors] = useState<Errors>({});
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    if (id) {
      fetchVehicle(id);
    }
  }, [id]);

  const fetchVehicle = async (id: string) => {
    if (id === undefined) {
      setFormValues(initialFleetVehicleDetailForm);
      return;
    }

    setIsLoading(true);

    let result;
    try {
      result = await getFleetVehicleAPI(id);
    } catch {
      setIsLoading(false);
      return;
    }

    setFormValues(result);
    setIsLoading(false);

    setErrors({});
  };

  // Promjena statusa preko značke — vozilo se dohvaća ponovno da se značka osvježi.
  const handleStatusChange = useCallback(() => {
    if (id) fetchVehicle(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (!id) return <></>;

  return (
    <>
      <div className="">
        <div className="bg-white rounded-t-md">
          <VehicleTabHeader
            vehicleId={id}
            vehicle={formValues}
            title={t(FLEET_VEHICLE_OFFER_SEARCH_PAGE_TITLE.text)}
            icon={FLEET_VEHICLE_OFFER_SEARCH_PAGE_TITLE.icon}
            iconColor={FLEET_VEHICLE_OFFER_SEARCH_PAGE_TITLE.iconColor}
            onStatusChange={handleStatusChange}
          />
        </div>
        <TabMenu vehicleId={id} />
        <div className="py-3 px-4">
          <Tabs
            tabs={[
              {
                label: "Prodaja vozila",
                queryParam: "sale",
                content: (
                  <div>
                    <VehicleOfferSaleSearchPage />
                  </div>
                ),
              },
              {
                label: "Najam vozila",
                queryParam: "rent",
                content: (
                  <div>
                    <VehicleOfferRentSearchPage />
                  </div>
                ),
              },
            ]}
          />
        </div>
      </div>

    </>
  );
};

VehicleOfferSearchPage.route = FleetVehicleRoutes.FleetVehicleOfferSearchPageRouter;

export default VehicleOfferSearchPage;
